import React, { memo } from "react";
import Grid from "../../assets/icons/Grid";
import List from "../../assets/icons/List";
import { GRID, LIST } from "./CollectionsContainer";

const ToggleView = ({ activeView, setActiveView }) => {
  return (
    <div className="relative flex justify-end items-center box-border rounded-[40px] w-full p-0 mx-auto h-[42px] z-[1] mb-[30px]">
      <button
        className={`cursor-pointer border-inherit py-[10px] px-4 ml-[10px] rounded-full flex items-center justify-center 
        object-contain text-base
      ${
        activeView === GRID
          ? "bg-black text-white hover:bg-black/80 hover:text-white"
          : "bg-transparent text-black hover:text-black/80"
      }`}
        onClick={() => setActiveView(GRID)}
      >
        <Grid />
      </button>
      <button
        className={`cursor-pointer border-inherit py-[10px] px-4 ml-[10px] rounded-full flex items-center justify-center 
        object-contain text-base
       ${
         activeView === LIST
           ? "bg-black text-white hover:bg-black/80 hover:text-white"
           : "bg-transparent text-black hover:text-black/80"
       }`}
        onClick={() => setActiveView(LIST)}
      >
        <List />
      </button>
    </div>
  );
};

export default memo(ToggleView);
